import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import '../../../node_modules/react-grid-layout/css/styles.css';
import SweetAlert from 'react-bootstrap-sweetalert';
import { WidthProvider, Responsive } from "react-grid-layout";
import _ from "lodash";
import "react-datetime/css/react-datetime.css";
import { getDDMMYYYY, getDDMMYYYYHHMMSS, getYYYYMMDD,getHyphenDDMMMYYYYHHMM, getHyphenYYYYMMDDHHMMSS, getYYYYMMDDHHMMSS, getHyphenDDMMYYYYHHMMSS } from '../common/utils'; 
import CustomLoadingCellRenderer from "../layouts/customLoadingCellRenderer";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import $ from "jquery";
import DrawMap from '../common/drawmap';
import Trucklocaction from '../layouts/truckslocation.js';
import redirectURL from "../redirectURL";
import Select from 'react-select'
import DatePicker from 'react-datepicker'
const infoBox = require('../common/google-infowindow');
const moment = require('moment');
const googleAnalytics = require("../common/googleanalytics");
const ResponsiveReactGridLayout = WidthProvider(Responsive);
var map;
const decipher = salt => {
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded => encoded.match(/.{1,2}/g)
        .map(hex => parseInt(hex, 16))
        .map(applySaltToChar)
        .map(charCode => String.fromCharCode(charCode))
        .join('');
}
var viewMarkersArr=[];
export default class TrucksGPSDataComponent extends Component {

    constructor(props) {
        super(props);
        this.state = 
        {
            pageTitle: "Truck GPS Data",
            eventGridAction: "gridAction",
            eventCounterAction: "counterAction",
            eventFormAction: "formAction",
        	routemap:'',
        	allmarkers:'',
        	trucks:[],
            truck_no:'',
            selected_truck_no : "",
        	startDate:'',
            endDate:'',
            mapinfo:'',
            mapinfoclick:'',
			defTransitCoords:'',
			activeMarker: {},
			selectedPlace: {},
			dealerCode:'',
			timelinesmarkers:[],
			viewtimelinemarkers:true,
			viewgoogleroutes:true,
			googleroutepath:[],
			loadshow:'show-n',
            open: false,
            alert:null,
            show: false,
			basicTitle:'',
			defaultColDef: {
				sortable: true,
			  filter: true,
			  resizable: true

            },
            gridshow:'show-m',
            filteredData : [],
            mapshow:'show-m',
            actgridbtn:"btn-success",
            actmapbtn:"btn-default",
			rowData: null,
			showTrucksList : "show-n",
			rowModelhighchartoptionsType: 'enterprise',
			rowGroupPanelShow: 'always',
			overlayNoRowsTemplate: "",
			frameworkComponents: {
              customLoadingCellRenderer: CustomLoadingCellRenderer,
              trucklocaction:Trucklocaction
		  },

			animateRows: true,
			debug: true,
			showToolPanel: false,
		  uppressAggFuncInHeader: true,
			  
		  childconfs: [],
		  childrow:[],
		  rowModelType: "serverSide",
		  paginationPageSize:50,
		  cacheBlockSize: 10,
          maxBlocksInCache: 1,
          truckNoList:[],
          overly : "show-n",
		  statusBar: {
			  statusPanels: [
				  {
				  statusPanel: "agTotalAndFilteredRowCountComponent",
				  align: "left"
				  },
				  {
				  statusPanel: "agTotalRowCountComponent",
				  align: "center"
				  },
				  { statusPanel: "agFilteredRowCountComponent" },
				  { statusPanel: "agSelectedRowCountComponent" },
				  { statusPanel: "agAggregationComponent" }
			  ]
		  },
		  sideBar: {
			  toolPanels: [
				  {
				  id: "columns",
				  labelDefault: "Columns",
				  labelKey: "columns",
				  iconKey: "columns",
				  toolPanel: "agColumnsToolPanel"
				  },
				  {
				  id: "filters",
				  labelDefault: "Filters",
				  labelKey: "filters",
				  iconKey: "filter",
				  toolPanel: "agFiltersToolPanel"
				  }
			  ]
		  },
		  detailCellRendererParams:{},
		  rowClassRules: {
			  "highlitRow": "data.transit_delay == 1",
			  "green":"data.status >= 3"

          }	,
          tolls : [],
          frequency:"",
          showmarkers : 0,
          maptruck: "",
          tottalDistance: [],
          totaldistanceval: 0,
          selectedType:[{label:'Driver Mobile No.' , value :"Driver Mobile No."}],
          mobileNumber : ''
    	      
        };
        this.setTruckno = this.setTruckno.bind(this);
        this.onClickShowTruckLocation = this.onClickShowTruckLocation.bind(this);
    }
    logPageView = () => {
        try {
            if (googleAnalytics.page.enableGA) {
                googleAnalytics.logPageView();
                let eventGridAction = googleAnalytics.page.actionType.gridAction + " - " + window.location.pathname;
                let eventCounterAction = googleAnalytics.page.actionType.counterAction + " - " + window.location.pathname;
                let eventFormAction = googleAnalytics.page.actionType.formAction + " - " + window.location.pathname;
                this.setState({eventGridAction: eventGridAction, eventCounterAction: eventCounterAction, eventFormAction: eventFormAction});
            } else {
            }
        } catch(error) {
            console.error("Error occured while logging to GA, error = ", error);
        }
    }
    componentDidMount(){
    	this.logPageView(); // Log page view to GA
        var params = {};
        redirectURL.post("consignments/getAllTrucksData",params).then((response)=>{
            try {
                 var trucks = response.data.map(function(e)
                {
                    if(e.truck_no != "")
                    {
                        return e.truck_no;
                    }
                })
				this.setState({
					truckNoList: trucks.map(e => { return { label: e, value: e } })
				});
			} catch (e) { }
        })
    	
    }
    selectOptionsItems() {
        let items = [];     
        this.state.trucks.forEach(item => {
        	if(item != '' && item != null)
    		{
        		items.push(<option key={item.truck_no} value={item.truck_no}>{item.truck_no}</option>); 
    		}
        });
        return items;
    }
    handlerStartDateTime = (date) => {
        if (this.state.endDate && date > this.state.endDate) {
            this.setState({
                show:true,
                basicTitle:"From Date should be less than To Date",
                type:"danger"
            })
        } else {
            this.setState({
                startDate: date
            });
        }
    }
    handlerEndDateTime = (date) => {
        if (this.state.startDate && date < this.state.startDate) {
            this.setState({
                show:true,
                basicTitle:"To Date should be greater than From Date",
                basicType:'danger'
            })
        } else {
            this.setState({
                endDate: date
            })
        }
    }
    initalList =(event)=>{
        $(".trucks-dropdown").removeClass("show-n");
        var dataset = this.state.truckNoList;
        dataset = dataset.slice(0,100);
        this.setState({
            filteredData : dataset,
            showTrucksList : "show-m",
        })
    }
    onClickTruck(event)
    {
         $("#inputTruck").val($(this).text());
    }
    formHandler = async (event) => {
        this.setState({
            loadshow:'show-m'
        })
        event.preventDefault();
        if (googleAnalytics.page.enableGA) {
            let pageTitle = this.state.pageTitle;
            let eventOptions = {
                "category": pageTitle,
                "action": this.state.eventFormAction,
                "label": googleAnalytics.page.action.formSubmittedGenerate,
            }
            googleAnalytics.logEvent(eventOptions);
        }
       var endDate = getHyphenYYYYMMDDHHMMSS(this.state.endDate)
       var formdata= {
    			truck_no:this.state.filteredData!= null || this.state.filteredData != undefined || this.state.filteredData != '' ?  this.state.filteredData?.value : '',
                mobile_no : this.state.mobileNumber ? this.state.mobileNumber : '',
    			startDate:getHyphenYYYYMMDDHHMMSS(this.state.startDate),
                endDate:endDate,
                frequency:this.state.frequency,
        }        
		if(localStorage.getItem("customer_code") !=undefined && localStorage.getItem("customer_code") !="undefined" && localStorage.getItem("customer_code") !="")
		{
			formdata.customer_code = localStorage.getItem("customer_code")
		}
        if(localStorage.getItem("email") !=undefined && localStorage.getItem("email") !="undefined" && localStorage.getItem("email") !="")
            {
                formdata.user_mail = localStorage.getItem("email")
            }
    	await redirectURL.post("/dashboard/gmap",formdata,{
            headers:{
            	'Content-Type': 'application/json',
                'Access-Control-Allow-Origin':"*",
                'Access-Control-Allow-Methods':'GET, POST, OPTIONS, PUT, DELETE, TOKEN',
                'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
            }
        })
        .then(
          async (result) => {
             var jsondata = result.data;
             var output = {
                coords:[]
             }   
             try{
                output = JSON.parse(jsondata.data)
             }
             catch(e){
                return e
             }
             if(jsondata.status == 'failure' || jsondata.status == 'Failure' || output?.status == 'failure')
             {
                this.setState({
                    show:true,
                    basicTitle:'No GPS Data available for this period',
					basicType:"danger",
                    loadshow:'show-n',
                    rowData:null,
                    mapinfo:'',
                })
             }
             else{
                var coordinates = JSON.parse(jsondata.data);
                var dataarr=[];
                var tottalDistance = [];
                coordinates.coords.map((item) => {
                    tottalDistance.push(parseFloat(item.cumm_distance));
                    dataarr.push({
                        "truck_no":item.truck_no, 
                        "lat":item.lat, 
                        "lng":item.lng, 
                        "speed":item.speed, 
                        "stime":item.stime,
                        "dist_from_prev_point":item.dist_from_prev_point, 
                        "received_on":item.received_on, 
                        "time_from_prev_point":item.time_from_prev_point,
                        "area" : item.area,
                        "state" : item.state,
                        "cumm_distance": item.cumm_distance,
                        "mobile_no" : item.mobile_no ? item.mobile_no : ''
                    })
                });
                 var pinnedBottomRowData = {}
                 pinnedBottomRowData['_id'] = "total";
                pinnedBottomRowData['truck_no'] = "";
                pinnedBottomRowData['lat'] = "";
                pinnedBottomRowData['lng'] = "";
                pinnedBottomRowData['speed'] = "";
                pinnedBottomRowData['stime'] = "";
                pinnedBottomRowData['dist_from_prev_point'] = "Total";
                pinnedBottomRowData['received_on'] = "";
                pinnedBottomRowData['time_from_prev_point'] = "Total";
                pinnedBottomRowData['area'] = "";
                pinnedBottomRowData['district'] = "";
                pinnedBottomRowData['state'] = "";
                pinnedBottomRowData['cumm_distance'] = arrayMax(tottalDistance);
                pinnedBottomRowData['total_travel_time_mins'] = "";
                this.setState({
                    rowData:dataarr,
                    mapinfo:JSON.parse(jsondata.data),
                    loadshow:'show-n',
                    tolls : JSON.parse(jsondata.data).tolls,
                    maptruck: formdata?.truck_no != undefined && formdata?.truck_no != '' && formdata?.truck_no != null ? formdata.truck_no : formdata.mobile_no,
                    tottalDistance: [pinnedBottomRowData],
                    totaldistanceval: arrayMax(tottalDistance)
                })
                this.renderMap()
             }   
          }
        )
        .catch(function (error) {
  		    console.error(error);
  		  });
    }

    onClickShowGrid(){
        this.setState({
            gridshow:'show-m',
            mapshow:'show-n',
            mapinfoclick:"",
            actgridbtn:"btn-success",
            actmapbtn:"btn-default"
        });
    }

    onClickShowMap(){
        this.setState({
            gridshow:'show-n',
            mapshow:'show-m',
            mapinfoclick:this.state.mapinfo,
            actgridbtn:"btn-default",
            actmapbtn:"btn-success"
        });
    }
    onClickHideAll(){
		this.setState({
			loadshow:'show-n',
			overly:'show-n',
			showTrucksList : "show-n",
        });
        
    }
    hideList(){
        this.setState({
			loadshow:'show-n',
			overly:'show-n',
			showTrucksList : "show-n",
        });
    }
	closeAlert = () => {
        this.setState({
            show: false
        });
    }
    setTruckno = (event)=>{
        this.setState({
            selected_truck_no : event.target.text
        })
    }

    checkHandler = (event) => {
    	
    	let name = event.target.name;
		let value = event.target.value;
    	this.setState({[name]:value});
    }
    renderMap = () => {   
		
		loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyCbVLHDKmRETk7xp5RZzUdMYPCZe7Is59w&libraries=places,drawing&callback=initMap");
		window.initMap = this.initMap
	}
    initMap = () => {
        var currentwindow;
		var dealer='';
		var tolls = this.state.tolls;
		
		var arr=[];
        var jsondata = this.state.mapinfo;
        var locations = jsondata.breaks;
        var arr = jsondata.coords;
		if(arr.length > 0 && typeof arr.length != undefined)
		{
            var lt=arr[0].lat;
            var ln=arr[0].lng;
		}
		else{
            var lt=21.141058047268885;
            var ln=72.65782317936426;
            
		}
        var routeinfo ;
        try{
			var mapOptions = {
				zoom: 13,
				zoomControl: true,
				mapTypeControl: true,
				scaleControl: true,
				streetViewControl: true,
				rotateControl: true,
				fullscreenControl: true,
				labels:true,
				mapTypeControlOptions: {
					mapTypeIds: ['satellite', 'roadmap'],
				},
				center: new window.google.maps.LatLng(lt,ln),
				mapTypeId: window.google.maps.MapTypeId.ROADMAP
			};			
		}
		catch(e){
			var mapOptions = {
				zoom: 13,
				zoomControl: true,
				mapTypeControl: true,
				scaleControl: true,
				streetViewControl: true,
				rotateControl: true,
				fullscreenControl: true,
				labels:true,
				mapTypeControlOptions: {
					mapTypeIds: ['satellite', 'roadmap'],
				},
				center: new window.google.maps.LatLng(28.4519751,77.0310713),
				mapTypeId: window.google.maps.MapTypeId.ROADMAP
			};
					
		}
        try{
			map = new window.google.maps.Map(document.getElementById('map'), mapOptions);
		}catch(e){}
		
		var bounds = new window.google.maps.LatLngBounds();
		bounds.extend(new window.google.maps.LatLng(lt,ln));
			// Create our info window content
		var currentinfowindow = null;
		var line=new window.google.maps.Polyline(
		{
			map:map,
			strokeColor: '#157254',
			strokeOpacity: 1.0,
			strokeWeight: 2.5,
            });
        if(arr.length > 0)
		{
            var allpoints = [];
			var arr1=[];
			if(this.state.timelinesmarkers.length > 0)
			{
				arr1 = this.state.timelinesmarkers.filter(function (value, index, arr) {
					return (index % ratio == 0);
				} );
            }
            var arr2=[];
            var darr=[];
            if(arr.length > 0)
			{
				darr = arr.filter(function (value, index, arr) {
					return (value.dist_from_prev_point > 0);
				} );
				if(darr.length < 2000)
				{
					var ratio = 1;
				}
				else{
					var ratio = 20;
				}
				arr2 = darr.filter(function (value, index, darr) {
					return (index % ratio == 0);
				} );
            }
            // view markers code
            if(arr2.length > 0)
            {  
                viewMarkersArr = arr;
                    for(var a=0;a<arr2.length;a++)
                    {
                        var marker = new window.google.maps.Marker({
                            position: new window.google.maps.LatLng(arr2[a].lat, arr2[a].lng),
                            icon: {
                                    path: window.google.maps.SymbolPath.CIRCLE,
                                    strokeColor:'#157254',
                                    fillColor:'#157254',
                                    fillOpacity:1,
                                    strokeWeight: 5,
                                    scale:1,
                                },
                            map: map,
                            content:arr2[a]
                        });
                        marker.setVisible(false);
                        window.google.maps.event.addListener(marker, 'mouseover', (function(marker) {
                            return function() {
                                var contentarr = []
                            var header = "Current Status"
                            contentarr.push({"key":"Time ", "value":getDDMMYYYYHHMMSS(marker.content.stime)})
                            contentarr.push({"key":"Speed ", "value":marker.content.speed+" KMPH"})
                            var contentString = infoBox("", header, contentarr,'')
                            infowindow.setContent(contentString);
                            currentwindow = infowindow;
                            infowindow.open(map, marker);
                            }
                        })(marker));
                        window.google.maps.event.addListener(marker, 'mouseout', function() {
                            infowindow.close();
                        });
        
                       
                    }
            }
            var routeinfo = jsondata.route_details;
            var icon_cnt = 100
            for(var i=0;i< arr2.length-1;i++)
            {
                var locationLatLng = [];
                locationLatLng.push(new window.google.maps.LatLng(arr2[i].lat,arr2[i].lng));
                locationLatLng.push(new window.google.maps.LatLng(arr2[i+1].lat,arr2[i+1].lng));
                if(icon_cnt % 10 == 0)
                {
                    var lineicon = [{
                                repeat:'100px',
                                path:[]
                            }];
                }else{lineicon=[]}
                icon_cnt = icon_cnt + 1
                var consignments_missing_route_line = new window.google.maps.Polyline({
                    map:map,
                    path : locationLatLng,
                    strokeColor: '#157254',
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    icons: lineicon
                });
                if(arr2[i].msgtype == "G")
                {
                    
                    consignments_missing_route_line.setOptions({
                        strokeColor : "#452a68",
                        strokeWeight: 5.5,
                    })
                }
                bounds.extend(new window.google.maps.LatLng(arr2[i].lat,arr2[i].lng));
            }
				var infowindow = new window.google.maps.InfoWindow();
					var marker, l;

					for (l = 0; l < locations.length; l++) {
					marker = new window.google.maps.Marker({
					position: new window.google.maps.LatLng(locations[l].lat, locations[l].lng),
					icon:require('../../assets/icons/cf.png'),
					map: map,
					});

					window.google.maps.event.addListener(marker, 'click', (function(marker, l) {
						return function() {						
						var contentarr = []
						var header = "Break";
						try{
							if(typeof this.props.mapFor != 'undefined')
							{
                                var timeinsecs = moment.parseZone(locations[l].break_start).format("x") - moment.parseZone(locations[l].break_start).format("x")
                                contentarr.push({"key":"Break Start", "value":locations[l].break_start})
                                contentarr.push({"key":"Break End", "value":locations[l].break_end})
                                contentarr.push({"key":"Break time", "value":timeConvert(locations[l].break_time_seconds)})
							}
							else
							{
                                contentarr.push({"key":"Break Start", "value":locations[l].break_start})
                                contentarr.push({"key":"Break End", "value":locations[l].break_end})
                                contentarr.push({"key":"Break time", "value":timeConvert(locations[l].break_time_seconds)})
                            }
						}
						catch(e){
                            contentarr.push({"key":"Break Start", "value":locations[l].break_start})
                            contentarr.push({"key":"Break End", "value":locations[l].break_end})
                            contentarr.push({"key":"Break time", "value":timeConvert(locations[l].break_time_seconds)})
						}
						var contentString = infoBox(marker.icon, header, contentarr,'')
						infowindow.setContent(contentString);
						currentwindow = infowindow;
						infowindow.open(map, marker);
						}
					})(marker, l));
					}
					marker = new window.google.maps.Marker({
						position: new window.google.maps.LatLng(arr[0].lat, arr[0].lng),
						icon:require('../../assets/icons/track_start.png'),
						map: map,	
					});
				window.google.maps.event.addListener(marker, 'click', (function(marker) {
						return function() {
                            var contentarr = []
						var header = "Starting Point"
						contentarr.push({"key":"Started at", "value": getDDMMYYYYHHMMSS(routeinfo.start_time)})
						var contentString = infoBox(marker.icon, header, contentarr,'')
						infowindow.setContent(contentString);
						currentwindow = infowindow;
						infowindow.open(map, marker);
						}
					})(marker));
				marker = new window.google.maps.Marker({
					position: new window.google.maps.LatLng(arr[(arr.length-1)].lat, arr[(arr.length-1)].lng),
					icon:require('../../assets/icons/truck-end.png'),
					map: map,	
				});
				window.google.maps.event.addListener(marker, 'click', (function(marker) {
						return function() {
                        var contentarr = []
						var header = "End Point"
						contentarr.push({"key":"End at", "value":getDDMMYYYYHHMMSS(routeinfo.end_time)})
						var contentString = infoBox(marker.icon, header, contentarr,'')	
						infowindow.setContent(contentString);	
						infowindow.setContent(contentString);
						currentwindow = infowindow;
						infowindow.open(map, marker);
						}
					})(marker));
            }
            try{
                if(tolls.length > 0)
                {
                    var infowindow = new window.google.maps.InfoWindow();
                    var l;
                    tolls.map(function(e,index){
                        var tollMarker = new window.google.maps.Marker({
                            position: new window.google.maps.LatLng(e.lat, e.lon),
                            icon:require('../../assets/icons/barrier.png'),
                            map: map,
                        });
                        window.google.maps.event.addListener(tollMarker, 'mouseover', (function(tollMarker, index) {
                            return function() 
                            {
                                var contentarr = []
                                var header = "Toll - "+e.name
                                contentarr.push({"key":"Address", "value":e.location})
                                var contentString = infoBox(tollMarker.icon, header, contentarr)
                                infowindow.setContent(contentString);
                                var currentwindow = infowindow;
                                infowindow.open(map, tollMarker);
                            }
                        })(tollMarker, index));
                        window.google.maps.event.addListener(tollMarker, 'mouseout', function() {
                            infowindow.close();
                            });
                    })  
                    
                }
            }catch(e){}
            map.fitBounds(bounds)
	}

    onClickShowTruckLocation(e){
        var lat = parseFloat(e.data.lat);
		var lng =parseFloat(e.data.lng);
		var data =e.data;
        var mapOptions = {
            zoom: 13,
            zoomControl: true,
            mapTypeControl: true,
            scaleControl: true,
            streetViewControl: true,
            rotateControl: true,
            fullscreenControl: true,
            labels:true,
            mapTypeControlOptions: {
                mapTypeIds: ['satellite', 'roadmap'],
            },
            center: new window.google.maps.LatLng(28.4519751,77.0310713),
            mapTypeId: window.google.maps.MapTypeId.ROADMAP
        };       
        map = new window.google.maps.Map(document.getElementById('map'), mapOptions);
        map.setCenter(new window.google.maps.LatLng(lat, lng));
		map.setZoom(22);
		var markerLatlng = new window.google.maps.LatLng(lat, lng);
		var image =  require('../../assets/icons/gmarker.png');
		var marker = new window.google.maps.Marker({
			position: markerLatlng,
			map: map,
			title:data.truck_no,
			icon:image
		});
		var contentarr = []
		var header = data.truck_no
		contentarr.push({"key":"City/Area", "value":data.area})
		contentarr.push({"key":"State", "value":data.state})
		var contentString = infoBox(marker.icon, header, contentarr,'')
		var infowindow = new window.google.maps.InfoWindow({
			content: contentString
		});
		marker.setAnimation(window.google.maps.Animation.DROP)
		marker.addListener('click', function() {
			infowindow.open(map, marker);
		});
		marker.setMap(map);
    }
    showmarkers(event)
  {
        var infowindow = new window.google.maps.InfoWindow();
        var markersArray = viewMarkersArr;
        if(event.target.value == 0)
		{
            if(markersArray.length > 0)
            {
                var stepby = Math.round(markersArray.length * 0.007)
                var counter = 1;
                var incrementby = 1;
                while(counter < markersArray.length)
                {
                    var marker = new window.google.maps.Marker({
                        position: new window.google.maps.LatLng(markersArray[counter].lat, markersArray[counter].lng),
                        icon: {
                            path: window.google.maps.SymbolPath.CIRCLE,
                            strokeColor:'#157254',
                            fillColor:'#157254',
                            fillOpacity:1,
                                strokeWeight: 5,
                                scale:1,
                            },
                        map: map,
                        content:markersArray[counter]
                    });
                    window.google.maps.event.addListener(marker, 'mouseover', (function(marker) {
                        return function() {
                        var contentarr = []
                        var header = "Current Status"
                        contentarr.push({"key":"Time ", "value":getDDMMYYYYHHMMSS(marker.content.stime)})
                        contentarr.push({"key":"Speed ", "value":marker.content.speed+" KMPH"})
                        var contentString = infoBox("", header, contentarr,'')    
                        infowindow.setContent(contentString);
                        infowindow.open(map, marker);
                        }
                    })(marker));
                    window.google.maps.event.addListener(marker, 'mouseout', function() {
                        infowindow.close();
                    });
                    counter = counter + incrementby;
                }
            }
        }
        else
        {
			viewMarkersArr.map(function(e){
				e.setVisible(false);
            });
            this.setState({
                showmarkers : 0
            })
        }
    }
    handleTruckNumber =(selectedoption) =>{
        this.setState({
            filteredData:selectedoption
        })
    }
    handleMobileNumber = (e) => {
        let value = e.target.value;
        if (value == '' || /^[6-9][0-9]*$/.test(value)) {
            this.setState({ mobileNumber: value });
        }
    }
    handleSelected =(selectedoption) =>{
        this.setState({
            selectedType:selectedoption
        })
    } 

    render(){
    	let order_cnt=[];
    	const dStyles={
				width:'100%',
				height:'100%'
		}
		const modalStyles  = {
            width:'500px !important',
            }
    const { open } = this.state;
    const columnwithDefs=[
        {
            headerName: "",
            field: "",
            width: 50,
            cellRendererSelector: function (params) {
                return {
                    component: Trucklocaction
                }
            }
        },
        {
            headerName: "Truck no/Mobile no",
            field: "truck_no",
            width: 180,
            filter: true,
            resizable: true,
            valueGetter:function(params){
                console.log("67890890",params.data)
                return params.data.mobile_no == '' ? params.data.truck_no : params.data.mobile_no
            }
        },
        {
            headerName: "Latitude",
            field: "lat",
            width: 120,
            filter: true,
            resizable: true,
            valueGetter: function (params) {
                return params.data.lat;
            }

        },
        {
            headerName: "Longitude",
            field: "lng",
            width: 120,
            filter: true,
            resizable: true,
            valueGetter: function (params) {
                return params.data.lng;
            }
        },
        {
            headerName: "Speed (Kms)",
            field: "speed",
            width: 100,
            filter: true,
            resizable: true

        },
        {
            headerName: "Packet Time",
            field: "stime",
            width: 140,
            filter: true,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.stime != "") {
                    return getHyphenDDMMYYYYHHMMSS(params.data.stime);
                }
                else {
                    return "";
                }

            },
            comparator: dateComparator,
        },
        {
            headerName: "Received On",
            field: "received_on",
            width: 140,
            filter: true,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.received_on != "NaT") {
                    return getHyphenDDMMYYYYHHMMSS(params.data.received_on);
                }
                else {
                    return "";
                }
            },
            comparator: dateComparator,
        },
        {
            headerName: "Time from previous point",
            field: "time_from_prev_point",
            width: 240,
            filter: true,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.time_from_prev_point != 'Total') {
                    return secondsToDhms(params.data.time_from_prev_point);
                }
                else {
                    return "";
                }
            }
        },
        {
            headerName: "Distance from previous point (Meters)",
            field: "dist_from_prev_point",
            width: 240,
            filter: true,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.dist_from_prev_point != 'Total') {
                    return convertMeters(params.data.dist_from_prev_point);
                }
                else {
                    return "Total";
                }
            }
        },
        {
            headerName: "Cummulative Distance (KM)",
            field: "cumm_distance",
            width: 140,
            filter: true,
            resizable: true,
            valueGetter: function (params) {
                return convertMeters(params.data.cumm_distance);
            }
        },   
    ]
        return (
            <div >
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
                    {this.state.alert}
                {/*Container-fluid starts*/} 
                <div className="container-fluid">
                <div className="col-sm-12 mt-10p mb-20p">
                        <h5 className="fbold f18">
                            <i className="icon-map cus-i"></i> <span>View Carrier Route</span>
                        </h5>
                    </div>
                    <div className="col-sm-12">
                        <div className="card card-tal" style={{ marginTop: "15px" }}>
                            <div className="card-body" style={{ padding: "20px 20px 10px" }}>
                                <div className="row col-xl-12 col-lg-12">
                                    <div className="row col-xl-12 col-lg-12">
                                        <div className={"trucks-dropdown " + this.state.showTrucksList}>
                                        </div>
                                        <form className="row theme-form col-xl-12 col-lg-12" onSubmit={this.formHandler}>
                                            <div className='col-2'>
                                                <label>Select Type</label>
                                                <Select
                                                    options={[{ label: "Truck", value: 'Truck' }, { label: "Driver Mobile No.", value: "Driver Mobile No." }]}
                                                    value={this.state.selectedType}
                                                    onChange={this.handleSelected.bind(this)}
                                                />
                                            </div>
                                            {this.state.selectedType?.value == 'Truck' ? <div className="col-xl-2 col-lg-2 form-group">
                                                <label>Select Truck<span style={{ color: "red" }}>*</span></label>
                                                <Select
                                                    options={this.state.truckNoList}
                                                    value={this.state.filteredData}
                                                    onChange={this.handleTruckNumber.bind(this)}
                                                />
                                            </div> : <div className='col-xl-2 col-lg-2 form-group'>
                                                <label>Enter Mobile No.<span style={{ color: "red" }}>*</span></label>
                                                <input className="form-control"
                                                    type='text'
                                                    value={this.state.mobileNumber}
                                                    onChange={(e) => this.handleMobileNumber(e)}
                                                    id='mobile_number'
                                                    maxLength={10}
                                                    required
                                                /></div>}
                                            <div className="col-xl-2 col-lg-2 form-group">
                                                <label>From Date <span style={{ color: "red" }}>*</span></label>
                                                <DatePicker
                                                    value={this.state.startDate}
                                                    selected={this.state.startDate}
                                                    showTimeInput
                                                    timeInputLabel="Edit Time:"
                                                    dateFormat="dd/MM/yyyy h:mm aa"
                                                    closeOnScroll={true}
                                                    onChange={(date) => this.handlerStartDateTime(date)}
                                                    className="datepicker-custom"
                                                    popperPlacement="bottom"
                                                    maxDate= {new Date()}
                                                    required
                                                />
                                            </div>
                                            <div className="col-xl-2 col-lg-2 form-group">
                                                <label>To Date <span style={{ color: 'red' }}>*</span></label>
                                                <DatePicker
                                                    value={this.state.endDate}
                                                    selected={this.state.endDate}
                                                    showTimeInput
                                                    timeInputLabel="Edit Time:"
                                                    dateFormat="dd/MM/yyyy h:mm aa"
                                                    closeOnScroll={true}
                                                    onChange={(date) => this.handlerEndDateTime(date)}
                                                    className="datepicker-custom"
                                                    popperPlacement="bottom"
                                                    maxDate = {new Date()}
                                                    required
                                                />
                                            </div>
                                            <div className="col-3">
                                                <label>Data Interval (Mins)</label>
                                                <input type="number" name="frequency" id="frequency" value={this.state.frequency} placeholder="Data Interval (Mins)" className="validateNumber form-control" onChange={this.checkHandler.bind(this)} />
                                            </div>
                                            <div className="col-1">
                                                <button type="submit" className="btn btn-success mt-25p">Submit</button>
                                            </div>
                                        </form>
                                    </div></div></div></div></div>
                    {(this.state.rowData != null)?
                        <div className="row col-xl-12 col-lg-12">
                            <div className="col-xl-6 col-lg-6">
                                    <div id="myGrid" style={{ height: "820px",width: "100%"}}  className={"ag-theme-balham "+(this.state.gridshow)}>
                                    <AgGridReact
                                        columnDefs={columnwithDefs}
                                        defaultColDef={this.state.defaultColDef}
                                        rowData={this.state.rowData}
                                        enableCharts={true}
                                        enableRangeSelection={true}
                                        onGridReady={this.onGridReady}
                                        onGridState={this.onGridState}
                                        statusBar={this.state.statusBar}
                                        sideBar={this.state.sideBar}
                                        paginationPageSize={this.state.paginationPageSize}
                                        pagination={true}
                                        frameworkComponents={this.state.frameworkComponents}
                                        enableCellChangeFlash={true}
                                        suppressCellFlash={true}
                                        gridOptions={{
                                            context: { componentParent: this }
                                        }}
                                        />
                                    </div>
                                  </div>
                                <div className={"col-xl-6 col-lg-6 white-bg "} style={{padding:"10px"}}>
                                <DrawMap
                                    context={this}
                                    mapFor={"truckgps"}
                                    tolls={this.state.tolls}
                                    mapinfo={this.state.mapinfo}
                                    defTransitCoords={""}
                                />
                                   
                                   <div className="col-xl-12 col-lg-12 n-p-0">
                                    <div className="crm-numbers pb-0">
                                        <h3 className="subH">View Details:</h3>
                                        <div className="col-xl-12 col-lg-12 row">
                                            <div className="col route-block">
                                                <label className="sidebar-label">Truck No/ Mobile No</label>
                                                <div>{this.state.maptruck}</div>
                                            </div>
                                            <div className="col route-block">
                                                <label className="sidebar-label">Start Time</label>
                                                <div>{(this.state.mapinfo.route_details.start_time != '') ? getDDMMYYYYHHMMSS(this.state.mapinfo.route_details.start_time) : "NA"}</div>
                                            </div>
                                            <div className="col route-block">
                                                <label className="sidebar-label">End Time</label>
                                                <div>{(this.state.mapinfo.route_details.end_time != '') ? getDDMMYYYYHHMMSS(this.state.mapinfo.route_details.end_time) : "NA"}</div>
                                            </div>

                                            <div className="col route-block">
                                                <label className="sidebar-label">Distance</label>
                                                <div>{(this.state.totaldistanceval / 1000).toFixed(2)} Kms</div>
                                            </div></div>
                                    </div>
                                </div>
                                </div> 
	                	</div>
                   :""}
                    <div className={"dataLoadpage " +(this.state.loadshow)}>
                    </div>
                    <div className={"dataLoadpageimg " +(this.state.loadshow)}>
                        <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                    </div>
                </div>                
                <div className={"overlay-part "+(this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
            </div>
        );
    }
}

function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

function dateComparator(date1, date2) {
    if(date1 != "" && date2 != "" && date1 != undefined && date2 != undefined ){
    var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
    date1 = date1.replace(date1.split(" ")[0].split("-")[1],date_1);
    var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
    date2 = date2.replace(date2.split(" ")[0].split("-")[1],date_2);
    var date1Number = monthToComparableNumber(date1);
    var date2Number = monthToComparableNumber(date2);
    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }
    return date1Number - date2Number;
    }
  }
function monthToComparableNumber(date) {
    if (date === undefined || date === null || date.length !== 16) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}

function getMonthNumber(monthName){
    var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep',
        'Oct', 'Nov', 'Dec'
        ];
    var monthNum = months.indexOf(monthName)+1;
    if(monthNum < 10){
        monthNum = "0"+monthNum.toString();
    }
    return monthNum;
}
$(document).ready(function(){
    $(document).on("click",".dropdown-truck-no",function(){
        var vals = $(this).text();
         $("#inputTruck").val(vals);
         $(".trucks-dropdown").removeClass("show-m");
         $(".trucks-dropdown").addClass("show-n");
    });

    $("body").on("click",function(e){
        var container = $("#inputTruck");
        if(!container.is(e.target))
        {
            try{
                if($(".trucks-dropdown").attr("class").includes("show-m") || $(".trucks-dropdown").attr("class") == "trucks-dropdown")
                {
                    $(".trucks-dropdown").removeClass("show-m");
                    $(".trucks-dropdown").addClass("show-n");
                }
            }catch(e){}
            
        }
        
        
    })
})

function loadScript(url){
    var index  =window.document.getElementsByTagName("script")[0]
    var script = window.document.createElement("script")
    script.src=url
    script.async=true
    script.defer = true
    index.parentNode.insertBefore(script,index)
}
  function timeConvert(n) {
      var num = n;
      var hours = (num / (3600));
      var rhours = parseInt(hours);
      var minutes = (num-(rhours*3600)) / (60);
      var rminutes = Math.round(minutes);
      return rhours + " hour(s) and " + rminutes + " minute(s).";
  }   

function ConvertMinutes(num){
    var d = Math.floor(num/1440); // 60*24
    var h = Math.floor((num-(d*1440))/60);
    var m = Math.round(num%60);
    return d+" Day(s) "+h+" Hrs "+m+" mins"
}


function convertMeters(metersValue)
{
    return (metersValue/1000).toFixed(2);
}

$(document).ready(function(){
    $(document).on('keyup',".validateNumber",function(){
        if(isNaN($(this).val()) == true){
            $(this).val($(this).val().slice(0,-1));
        }
    });
});

function arrayMax(arr) {
    return arr.reduce(function (p, v) {
        return (p > v ? p : v);
    });
}
function secondsToDhms(seconds) {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor(seconds % (3600 * 24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);

    var dDisplay = d >= 0 ? d + (d == 1 ? " Day " : " Days ") : "";
    var hDisplay = h >= 0 ? h + (h == 1 ? " Hr " : " Hrs ") : "";
    var mDisplay = m >= 0 ? m + (m == 1 ? " Mins " : " Mins ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    return dDisplay + hDisplay + mDisplay;
}
